module.exports = __webpack_public_path__ + "static/media/icon_new_list.c5ad3c8f.svg";